exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*$vs-colors: (\n        lightest: rgba(60, 60, 60, 0.26),\n        light: rgba(60, 60, 60, 0.5),\n        dark: #333,\n        darkest: rgba(0, 0, 0, .15),\n) !default;*/\n.news-card .zoom-wrapper {\n  overflow: hidden;\n  height: 223px;\n}\n@media screen and (min-width: 768px) {\n.news-card .zoom-wrapper {\n    height: 279px;\n}\n}\n.news-card .image-wrapper {\n  background-size: cover;\n  background-position: center;\n  transition: transform 0.2s;\n}\n.news-card:hover .image-wrapper {\n  transform: scale(1.1);\n}", ""]);

// exports
